import NoPage from '@/views/404.vue'
import UserIndex from '@/views/index'
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// 解决vue路由重复导航错误
// 获取原型对象上的push函数
const originalPush = Router.prototype.push
// 修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

const routes = [
  {
    path: '/',
    name: 'UserIndex',
    component: UserIndex
  },
  {
    path: '*',
    name: 'NoPage',
    component: NoPage
  }
]

const router = new Router({
  mode: 'history',
  routes
})

// router.beforeEach((to, from, next) => {
//   console.log(from)
//   console.log(to)
//   document.body.scrollTop = 0
//   document.documentElement.scrollTop = 0
//   next()
// })

export default router



// WEBPACK FOOTER //
// ./src/router/index.js